import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { useMemo } from 'react';
import { ScopeOfWork_DeliverableStatus, type Sow_DeliverableStatus } from '@/modules/__generated__/graphql/switchboard-generated';
interface DeliverableStatusChipProps {
  status: ScopeOfWork_DeliverableStatus | Sow_DeliverableStatus;
}
function DeliverableStatusChip(t0) {
  const $ = _c(14);
  const {
    status
  } = t0;
  let t1;
  bb0: {
    const normalizedStatus = status as ScopeOfWork_DeliverableStatus;
    switch (normalizedStatus) {
      case ScopeOfWork_DeliverableStatus.InProgress:
        {
          let t2;
          if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
              label: "In Progress",
              bgColor: "bg-status-progress/30",
              textColor: "text-status-progress"
            };
            $[0] = t2;
          } else {
            t2 = $[0];
          }
          t1 = t2;
          break bb0;
        }
      case ScopeOfWork_DeliverableStatus.Delivered:
        {
          let t2;
          if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
              label: "Delivered",
              bgColor: "bg-status-success/30",
              textColor: "text-status-success"
            };
            $[1] = t2;
          } else {
            t2 = $[1];
          }
          t1 = t2;
          break bb0;
        }
      case ScopeOfWork_DeliverableStatus.Blocked:
        {
          let t2;
          if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
              label: "Blocked",
              bgColor: "bg-destructive/30",
              textColor: "text-destructive"
            };
            $[2] = t2;
          } else {
            t2 = $[2];
          }
          t1 = t2;
          break bb0;
        }
      case ScopeOfWork_DeliverableStatus.Canceled:
        {
          let t2;
          if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
              label: "Canceled",
              bgColor: "bg-destructive/30",
              textColor: "text-destructive"
            };
            $[3] = t2;
          } else {
            t2 = $[3];
          }
          t1 = t2;
          break bb0;
        }
      case ScopeOfWork_DeliverableStatus.Draft:
      case ScopeOfWork_DeliverableStatus.Todo:
        {
          const t2 = status === ScopeOfWork_DeliverableStatus.Draft ? "Draft" : "To do";
          let t3;
          if ($[4] !== t2) {
            t3 = {
              label: t2,
              bgColor: "bg-status-warning/30",
              textColor: "text-status-warning"
            };
            $[4] = t2;
            $[5] = t3;
          } else {
            t3 = $[5];
          }
          t1 = t3;
          break bb0;
        }
      case ScopeOfWork_DeliverableStatus.WontDo:
        {
          let t2;
          if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
              label: "Won't do",
              bgColor: "bg-muted",
              textColor: "text-muted-foreground"
            };
            $[6] = t2;
          } else {
            t2 = $[6];
          }
          t1 = t2;
          break bb0;
        }
      default:
        {
          let t2;
          if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = {
              label: "To do",
              bgColor: "bg-status-warning/30",
              textColor: "text-status-warning"
            };
            $[7] = t2;
          } else {
            t2 = $[7];
          }
          t1 = t2;
        }
    }
  }
  const {
    label,
    bgColor,
    textColor
  } = t1;
  let t2;
  if ($[8] !== bgColor || $[9] !== textColor) {
    t2 = cn("inline-flex items-center justify-center rounded-md px-3 py-px text-xs/5.5 font-semibold text-nowrap uppercase", bgColor, textColor);
    $[8] = bgColor;
    $[9] = textColor;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== label || $[12] !== t2) {
    t3 = <div className={t2}>{label}</div>;
    $[11] = label;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  return t3;
}
export { DeliverableStatusChip };